<script>
export default {
    name: "BitrixAuditForm",
    props: {
        containerId : { 
            type: String,
            required: true
        }
    },
    render: function(createElement){


        const formScript = createElement(
            'script',
            {
                attrs:{
                    id: "bx24_form_inline",
                    'data-skip-moving' : true
                },
            },
            `
                (function(w, d, u, b){
                    w['Bitrix24FormObject'] = b;
                    
                    w[b] = w[b] || function(){
                        arguments[0].ref = u; 
                        (w[b].forms = w[b].forms || [] ).push(arguments[0])
                    };

                    if(w[b]['forms']) return;
                    
                    var s=d.createElement('script');
                    s.async=1;
                    s.src=u+'?'+(1*new Date());

                    var h = d.getElementsByTagName('script')[0];
                    
                    h.parentNode.insertBefore(s,h);
                
                })( window, document, 'https://sovtes.bitrix24.ua/bitrix/js/crm/form_loader.js', 'b24form' );

                b24form({ "id":"17", "lang":"ru", "sec":"fyxud2", "type":"inline", node: document.getElementById('${this.containerId}') });        
            `
        );

        const wrapper = createElement(
            "div",
            {
                attrs: {
                    id: "bitrix-audit-form"
                }
            },
            [
                formScript
            ]
        )

        return wrapper;
    }


}
</script>
<style lang="scss" scoped>

</style>
